<div [ngClass]="{ 'show-nav': navBarValidation, 'hide-nav': !navBarValidation }">

  <!-- Header section starts -->
  <header>
    <a href="javascript:void(0);"
      class="nw-header__skip"
      (click)='skipToMainContent()'
    translate>Skip to main content</a>
    @if (isCommercialSessionPolicy && !appWindow.frameElement && showHeader) {
      @if (!isAuthenticated) {
        <bolt-header logohref="{{environment.NATIONWIDE.accountSummaryPage}}">
          <div slot="main-actions">
            <bolt-button type="ghost" class="bolt-header-desktop-only" href="{{environment.FOOTER_LINKS.contactUs}}" target="_blank">Contact us</bolt-button>
          </div>
          <ul slot="navigation-primary">
            <li type="ghost" class="bolt-header-mobile-only"><a href="{{environment.FOOTER_LINKS.contactUs}}" target="_blank">Contact us</a></li>
          </ul>
        </bolt-header>
      }
      @if (isAuthenticated && headerData) {
        <div [class.bolt-space-bottom-sm]="farmflexDeductiblePage">
            <bolt-header logohref="{{environment.NATIONWIDE.accountSummaryPage}}">
          <div slot="main-actions">
            <bolt-button type="ghost" class="bolt-header-desktop-only" href="{{environment.AUTH_HEADER_LINKS.contactUs}}" target="_blank">Contact us</bolt-button>
            <bolt-button color="secondary" class="bolt-header-desktop-only" href="{{environment.AUTH_HEADER_LINKS.logout}}">Log out</bolt-button>
            <bolt-button type="ghost" color="secondary" class="bolt-header-mobile-only" size="sm" href="{{environment.AUTH_HEADER_LINKS.logout}}">Log out</bolt-button>
          </div>
          <ul slot="navigation-primary">
            <li class="bolt-header-mobile-only"><a href="{{environment.AUTH_HEADER_LINKS.contactUs}}" target="_blank">Contact us</a></li>
          </ul>
        </bolt-header>
        </div>
        @if (headerData?.username && !farmflexDeductiblePage) {
            <div class="bolt-space-bottom-sm">
                <bolt-row class="business-name-container">
                  <span class="business-name">ACCOUNT VIEW FOR: {{headerData.username}}</span>
                </bolt-row>
                <bolt-divider></bolt-divider>
            </div>
        }
      }
    }
    @if (!isCommercialSessionPolicy && (isPreEfnol && !tracker  || (checklist && !isAuthenticated) || (understandCoverages && !isAuthenticated)) && !testPage && !propertyEfnol && !isPropertyClaims && !isPropertyIdentificationReturning) {
      <is-pre-efnol-header
      ></is-pre-efnol-header>
    }
    @if (!isCommercialSessionPolicy && (!isPreEfnol && !claimList && !tracker && !checklist && !understandCoverages)&& !testPage && !propertyEfnol && !isPropertyClaims && !isPropertyIdentificationReturning) {
      <is-efnol-header
      > </is-efnol-header>
    }
    @if (!isCommercialSessionPolicy && !tracker && (isRegisteredAuthenticated && headerData && showHeader && (claimList || checklist || understandCoverages))&& !testPage && !propertyEfnol && !isPropertyClaims && !isPropertyIdentificationReturning) {
      <authenticated-header
        [headerData]="headerData"
        (linkClick)="linkClicked($event)">
      </authenticated-header>
    }
    @if (!isCommercialSessionPolicy && (testPage || tracker || propertyEfnol || isPropertyClaims || (isPropertyIdentificationReturning && isRegisteredAuthenticated))) {
      <app-isc-header [userType]="propertyUserType"></app-isc-header>
    }
  </header>
  <!-- Header section ends-->


  <div [ngClass]="{ 'bolt-container': isCommercialSessionPolicy }">
    @if (!isProd()) {
      <is-nw-test-tool
      aria-hidden="true"></is-nw-test-tool>
    }
    <div #mainContent
    tabindex="-1"></div>
    <router-outlet></router-outlet>
    @if (!appWindow.frameElement) {
      <is-timeout-outlet></is-timeout-outlet>
    }
  </div>

  <footer>
    <div>
      @if (isCommercialSessionPolicy && showFooter && footerData) {
        <is-footer
          [footerData]="footerData"
        (linkClick)="linkClicked($event)"></is-footer>
      }
      @if (!isCommercialSessionPolicy && showFooter && footerData) {
        <is-footer
          [footerData]="footerData"
        (linkClick)="linkClicked($event)"></is-footer>
      }
    </div>
  </footer>
  <is-oauth-iframe style="display: none;"></is-oauth-iframe>
</div>
